import React from 'react';
import styles from '../Dashboards.module.css';
import SectionedList from '../../common/SectionedList/SectionedList';

function ExtensionList({
  selectedReport,
  setSelectedReport,
  selectedReportType,
  setSelectedReportType,
  context,
}) {
  const options = Object.values(window.aha?.panels || []).map(panel => {
    const nameDiv = (
      <div className={styles.ReportListReportName}>
        <i className='fa-regular fa-code' />
        {panel.name}
      </div>
    );

    return {
      text: nameDiv,
      value: panel.id,
      report: panel,
    };
  });

  return (
    <div className={styles.ReportListMain}>
      <SectionedList
        options={[{ key: 'report-list', children: options }]}
        onClick={option => setSelectedReport(option.report)}
        selected={selectedReport && selectedReport.id}
      />
    </div>
  );
}

export default ExtensionList;
